import React from 'react';
import {
  Grid,
} from '@material-ui/core';
import clsx from 'clsx';

import { useSelector } from 'react-redux';
import MediaExportTabStyles from './styles';
import {
  CopyVideoLinkAction,
  CopyVideoTokenAction,
  CopyVideoThumbnailLinkAction,
  CopyVideoPreviewAction,
  CopyString,
} from './actions';
import { selectMediaExport } from '../../../../../../store/modules/articles/selectors';
import * as Sentry from '@sentry/react';

type copyObject = {
  title: string;
  copyComponent: React.ReactNode;
};

export const ExportTab = () => {
  const classes = MediaExportTabStyles();
  const { media } = useSelector(selectMediaExport);

  // START_DEBUG
  // 2020.12.25,BN: extra debug code here to reveal information about reference data
  // which seems to be missing sometimes
  const extraDebugChecks = true;
  if (extraDebugChecks) {
    const refCheckOk = !( media?.ref?.video?.ref === undefined );
    if ( !refCheckOk ) {
      Sentry.captureException( new Error('Export reference check not OK') );
    }

    const playerIframeUrl = (media?.ref?.video?.ref?.player_iframe_url || '');
    const refCheckIframeUrlOk = ( playerIframeUrl.length === 0 );
    if ( refCheckIframeUrlOk ) {
      Sentry.captureException( new Error('Export reference check not OK (player_iframe_url)') );
    }
  }
  // END_DEBUG


  const links: copyObject[] = [
    {
      title: 'MP4 video link',
      copyComponent: <CopyVideoLinkAction />,
    },
    {
      title: 'PitchHub media preview link',
      copyComponent: <CopyVideoPreviewAction />,
    },

    {
      title: 'Video thumbnail link',
      copyComponent: <CopyVideoThumbnailLinkAction />,
    },

    {
      title: 'Video ID (Homebot.ai)',
      copyComponent: <CopyVideoTokenAction />,
    },

    {
      title: 'Video Player Hosted Page',
      copyComponent: <CopyString
        title="Video Player Hosted Page"
        copyContent={media?.ref?.video?.ref?.player_hosted_url || ''}
      />,
    },
    {
      title: 'Video Player Embed Code',
      copyComponent: <CopyString
        title="Video Player Embed Code"
        copyContent={media?.ref?.video?.ref?.player_iframe_embed_code || ''}
      />,
    },
    {
      title: 'Video Player Embed URL',
      copyComponent: <CopyString
        title="Video Player Embed URL"
        copyContent={media?.ref?.video?.ref?.player_iframe_url || ''}
      />,
    },
  ];

  return (
    <>
      <Grid container className={clsx(classes.row, classes.title)}>Export Type</Grid>
      {links.map((obj, i) => (
        <Grid key={i} container className={classes.row} alignItems="center">
          <Grid item>{obj.title}</Grid>
          <Grid item className={classes.actionContainer}>
            {obj.copyComponent}
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default ExportTab;
